import type { RefillMiddleware } from '../../boardMVC/models/tray/RefillMiddleware';
import { MacroBalancingRefillMiddleware } from './MacroBalancingRefillMiddleware';
import { macroBalancingConfig } from './macroBalancingConfig';
import type { MacroBalancingDependencies, MacroBalancingState } from './types';

export class MacroBalancingController {
  private initialized = false;

  private dependencies: MacroBalancingDependencies | null = null;

  public init(dependencies: MacroBalancingDependencies): void {
    this.dependencies = dependencies;
    this.initialized = true;
    if (Date.now() - this.getState().lastPlayed > macroBalancingConfig.resetTime) {
      this.updateAbilityScore(0, false);
    }

    this.dependencies.onLevelWin.connect((data) => {
      const current = this.getState().abilityScore;
      this.updateAbilityScore(data.levelIndex > 9 ? current + 2 : current, false);
    });

    this.dependencies.onLevelFailed.connect(() => {
      this.updateAbilityScore(Math.max(0, this.getState().abilityScore - 1), false);
    });

    this.dependencies.onRevive.connect(() => {
      this.updateAbilityScore(this.getState().abilityScore, true);
    });

    this.dependencies.onIAPPurchase.connect(() => {
      this.updateAbilityScore(0);
    });
  }

  private updateAbilityScore(score: number, attemptOverride: boolean | null = null): void {
    if (!this.dependencies) return;

    this.dependencies.observable.updateValue({
      macroBalancing: {
        abilityScore: score,
        lastPlayed: Date.now(),
        attemptOverride: attemptOverride ?? this.getState().attemptOverride,
      },
    });
  }

  private getState(): MacroBalancingState {
    if (!this.dependencies) {
      throw new Error('MacroBalancingController not initialized');
    }
    const { macroBalancing } = this.dependencies.observable.getValue();
    return { abilityScore: 0, lastPlayed: Date.now(), attemptOverride: false, ...(macroBalancing ?? {}) };
  }

  public getMacroBalancingRefillMiddleware(getGoalProgress: () => number): RefillMiddleware {
    if (!this.initialized || !this.dependencies) throw new Error('MacroBalancingController not initialized');

    return new MacroBalancingRefillMiddleware({
      isDev: this.dependencies.isDev,
      observable: this.dependencies.observable,
      getGoalProgress,
    });
  }
}
